// Imports for external libraries go here.
import { FC, useEffect, useState } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { Image, Link, useCheckBreakpoint } from '@marriott/mi-ui-library';
// Imports for internal (to the monorepo) libraries go here,
import { StyledHeader } from './Header.styles';
import { HeaderProps, HeaderMenuItem } from './Header.types';
import { mailConst } from '../../util/constants';
import { brandColorSchemeGenerator } from '../../util/constants';
import { useRouter } from 'next/router';
import DOMPurify from 'isomorphic-dompurify';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
import { LanguageSelector } from '../../molecules/LanguageSelector';
import { formatLanguageDataForSelector, isMobileAppBrowser } from '../../util/helpers';
import { getUserDetails, useUserDetailsGlobalStore } from '@marriott/mi-store-utils';
import { SignInDrawer } from '../../molecules/SignInDrawer/SignInDrawer';
import { SignInModal } from '../../molecules/SignInModal';
import { updateDatalayer } from '../../util/dataLayer/datalayerUtil';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Header: FC<HeaderProps> = (props: any) => {
  const isMobileViewPort = !useCheckBreakpoint('viewportL');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { formData, formValidation, setFormData, isFormValid, validateForm, setFormValidation } =
    useCreateSurveyStore();

  const [isLoading, setIsLoading] = useState(true);
  const [propertyName, setPropertyName] = useState(null);
  const [propertyLogo, setPropertyLogo] = useState(null);
  const [hotelPhoneNumber, setHotelPhoneNumber] = useState(null);
  const [hotelEmail, setHotelEmail] = useState(null);
  const [appView, setAppView] = useState(true);

  const [confirmationNumber, setConfirmationNumber] = useState(null);
  const [modalType, setModalType] = useState<'exitModal' | 'submitModal' | 'problemModal' | 'alreadySubmittedModal'>(
    'submitModal'
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  useEffect(() => {
    setPropertyName(props.propertyName || formData?.property_config?.hotel_name);
    setPropertyLogo(props.headerLogo || formData?.property_config?.logo_url);
    setHotelPhoneNumber(
      props.hotelPhoneNumber ||
        (formData?.property_config?.phone_number
          ? `+${formData.property_config.phone_number.country_code} ${formData.property_config.phone_number.area_code} ${formData.property_config.phone_number.phone_number}`
          : '')
    );
    setHotelEmail(props.hotelEmail || formData?.property_config?.hotel_contact_email);
    setConfirmationNumber(props.confirmationNumber || formData?.reservation?.confirmationNumber);
    setAppView(formData?.appView);
  }, [
    formData?.property_config?.hotel_name,
    formData?.property_config?.logo_url,
    formData?.property_config?.hotel_contact_email,
    formData?.reservation?.confirmationNumber,
    props.confirmationNumber,
    props.hotelPhoneNumber,
    props.propertyName,
    props.headerLogo,
    props.hotelEmail,
    formData?.property_config?.phone_number,
  ]);

  useEffect(() => {
    if (
      props?.confirmationNumber ||
      props?.hotelPhoneNumber ||
      props?.hotelEmail ||
      props?.isAuthorMode ||
      formData?.marshaCode ||
      formData?.confirmationNumber ||
      formData?.property_config?.hotel_name
    ) {
      setIsLoading(false);
    }
  }, [
    props.confirmationNumber,
    props.hotelPhoneNumber,
    props.hotelEmail,
    props?.isAuthorMode,
    formData?.marshaCode,
    formData?.confirmationNumber,
    formData?.property_config?.hotel_name,
  ]);
  useEffect(() => {
    if (isMobileAppBrowser() && getPushSource == 'true') {
      setFormData({
        ...formData,
        appView: true,
      });
    }
  }, []);
  const { OUTLET_ADDITIONAL_SECTION, OUTLET_EMAIL_CONTACT, EXTERNAL_LINK } = mailConst;

  // Destructure headerLinks from props.model
  const { headerLinks, language, langLinks, signInTargetDisabledFlagAlternate = false } = props.model;
  const router = useRouter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const urlQueryParams: Record<string, any> = router.query;
  // fetch the pushSource param from url - it will return either true or undefined
  const getPushSource = urlQueryParams['pushSource'];
  let clickNav = false;
  let loadingFalse = true;
  if (
    urlQueryParams['page'] &&
    (Object.values(urlQueryParams['page']).includes('dining') ||
      Object.values(urlQueryParams['page']).includes('experiences') ||
      Object.values(urlQueryParams['page']).includes('review') ||
      // Object.values(urlQueryParams['page']).includes('thank-you') ||
      Object.values(urlQueryParams['page']).includes('dining.mi') ||
      Object.values(urlQueryParams['page']).includes('experiences.mi') ||
      Object.values(urlQueryParams['page']).includes('review.mi'))
    // Object.values(urlQueryParams['page']).includes('thank-you.mi')
  ) {
    loadingFalse = false;
  }
  if (
    urlQueryParams['page'] &&
    (Object.values(urlQueryParams['page']).includes('guest-details') ||
      Object.values(urlQueryParams['page']).includes('dining') ||
      Object.values(urlQueryParams['page']).includes('experiences') ||
      Object.values(urlQueryParams['page']).includes('review') ||
      // Object.values(urlQueryParams['page']).includes('thank-you') ||
      Object.values(urlQueryParams['page']).includes('guest-details.mi') ||
      Object.values(urlQueryParams['page']).includes('dining.mi') ||
      Object.values(urlQueryParams['page']).includes('experiences.mi') ||
      Object.values(urlQueryParams['page']).includes('review.mi'))
    // Object.values(urlQueryParams['page']).includes('thank-you.mi')
  ) {
    clickNav = true;
  }

  const pathName = router.asPath;
  const [marshaFormData, setMarshaFormData] = useState<string>('');
  const [confirmationFormData, setConfirmationFormData] = useState<string>('');
  const [signInTargetDisabledFlagVar, setSignInTargetDisabledFlagVar] = useState<boolean>(false);
  useEffect(() => {
    setMarshaFormData(formData?.property_config?.marsha_cd);
    setConfirmationFormData(props?.confirmation_no || formData?.confirmationNumber);
    setSignInTargetDisabledFlagVar(signInTargetDisabledFlagAlternate);
  }, [formData?.marshaCode, formData?.confirmationNumber, signInTargetDisabledFlagAlternate]);
  useEffect(() => {
    if (marshaFormData != '') {
      setFormData({
        ...formData,
        isSignInFeatureDisable: signInTargetDisabledFlagVar,
      });
    }
  }, [signInTargetDisabledFlagVar]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useEffect(() => {
    if (props.isAuthorMode) return;

    // Wait until sessionData is resolved
    if (props?.sessionData === undefined) return;

    let fullUrlTo: string = '';
    let alreadyHasMarsha = false;
    let alreadyHasConfirmation = false;
    const protocol = window.location.protocol;
    const host = window.location.host;
    fullUrlTo = `${protocol}//${host}${pathName}`;

    if (!fullUrlTo.includes('marshaCode')) {
      fullUrlTo = fullUrlTo + '?marshaCode=' + marshaFormData;
    } else {
      alreadyHasMarsha = true;
    }
    if (!fullUrlTo.includes('confirmationNumber')) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const confirmationConfNo =
        JSON.parse(window.sessionStorage.getItem('BROWSERCONF') || '""') || confirmationFormData;
      fullUrlTo = `${fullUrlTo}&confirmationNumber=${confirmationConfNo}`;
    } else {
      alreadyHasConfirmation = true;
    }

    if (props?.env == 'lower') {
      if (!props?.sessionData?.cacheData?.data?.Prearrival?.brandCode && !alreadyHasConfirmation && !alreadyHasMarsha) {
        window.location.replace(fullUrlTo);
      }
    } else {
      if (!props?.sessionData?.cacheData?.data?.Prearrival?.brandCode && !alreadyHasConfirmation && !alreadyHasMarsha) {
        window.location.replace(fullUrlTo);
      }
    }
    if (alreadyHasMarsha && !alreadyHasConfirmation) {
      router.replace(fullUrlTo);
    }
  }, [marshaFormData, confirmationFormData, props?.sessionData, pathName, props?.isAuthorMode]);

  const [brandCdSetPage, setBrandCdSetPage] = useState('');
  useEffect(() => {
    if (props?.brandCode) {
      if (props?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'header'));
      } else {
        setBrandCdSetPage(brandColorSchemeGenerator(props?.brandCode, 'header'));
      }
    } else {
      if (formData?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'header'));
      } else {
        setBrandCdSetPage(
          brandColorSchemeGenerator(formData?.property_config?.brand_cd || formData?.brandCode, 'header')
        );
      }
    }
  }, [props?.brandCode, formData?.property_config?.brand_cd, formData?.brandCode]);
  const mockLanguageSelectorModal = {
    languageSelectorTitle: 'Select your language',
    langNavList: formatLanguageDataForSelector(langLinks || [], false),

    ':type': 'mi-aem-luxury-spa/components/content/language-selector',
  };

  const [languageSelectorModal, setLanguageSelectorModal] = useState(mockLanguageSelectorModal);
  useEffect(() => {
    if (props?.brandCode) {
      if (props?.property_config?.non_branded_flg === 'Y') {
        console.log('Non branded property - setting NBF brand colors');
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'header'));
      } else {
        setBrandCdSetPage(brandColorSchemeGenerator(props?.brandCode, 'header'));
      }
    } else {
      if (formData?.property_config?.non_branded_flg === 'Y') {
        setBrandCdSetPage(brandColorSchemeGenerator('NBF', 'header'));
      } else {
        setBrandCdSetPage(
          brandColorSchemeGenerator(formData?.property_config?.brand_cd || formData?.brandCode, 'header')
        );
      }
    }
    setLanguageSelectorModal(props?.languageSelectorModal ?? mockLanguageSelectorModal);
  }, [formData?.property_config?.brand_cd, props?.brandCode, formData?.isNavError]);
  const hasAlertMsg = () => {
    return !!document.querySelector('body .alert-msg');
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (e: any) => {
    e.preventDefault();
    const path = e?.target?.href?.split('/').pop();
    const newPath = pathName.replace(/\/[^/]*$/, `/${path}`);

    window.dispatchEvent(new CustomEvent('validate-dynamic-section'));
    window.dispatchEvent(new CustomEvent('validate-guest-details'));

    const fullUrl = `${window.location.origin}/${path}`;
    if (hasAlertMsg()) {
      setFormValidation(true);
    } else {
      if (fullUrl.includes('guest-details')) {
        if (validateForm()) {
          router.push(newPath);
        } else {
          setFormValidation(true);
        }
      } else {
        if (validateForm()) {
          router.push(newPath);
        } else {
          setFormValidation(true);
        }
      }
    }
  };

  const [isLanguageSelectorOpen, setIsLanguageSelectorOpen] = useState(false);

  // const [isSignInOpen, setIsSignInOpenOpen] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toggleKeyHandler = (event: any) => {
    if (event.key === 'Enter') {
      setIsLanguageSelectorOpen(!isLanguageSelectorOpen);
    }
  };
  const toggleHandler = () => {
    setIsLanguageSelectorOpen(!isLanguageSelectorOpen);
  };
  const userProfileData = useUserDetailsGlobalStore(state => state);
  const isRememberedUser = useUserDetailsGlobalStore(state => state.rememberedUser);
  const isSignedInUser = useUserDetailsGlobalStore(state => state.isSignedInUser);

  const { headerSubtext } = userProfileData;

  const toggleSignInHandlerClose = () => {
    setFormData({ ...formData, isSignInDrawerOpen: false, isSignInDrawerSideBarOpen: false });
  };
  const toggleSignInHandlerShow = () => {
    if (isSignedInUser) {
      setFormData({ ...formData, isSignInDrawerSideBarOpen: true });
    } else {
      setFormData({ ...formData, isSignInDrawerOpen: true });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      getUserDetails(true);
    };

    fetchData();

    if (formData && formData?.isSignInDrawerOpen && formData?.marshaCode != '') {
      setFormData({
        ...formData,
        isSignInDrawerOpen: false,
      });
    }
  }, []);

  useEffect(() => {
    if (formData && userProfileData && headerSubtext) {
      if (isRememberedUser) {
        setFormData({
          ...formData,
          isRememberUser: true,
          isUserEnableSignIn: false,
        });
      } else {
        setFormData({
          ...formData,
          isUserEnableSignIn: true,
          isRememberUser: false,
        });
      }
    }
  }, [userProfileData]);

  useEffect(() => {
    if (isSignedInUser && formData?.isSignInDrawerOpen) {
      setFormData({
        ...formData,
        isSignInDrawerOpen: false,
      });
    }
  }, [isSignedInUser]);

  useEffect(() => {
    const onLoad = () => {
      if (!isSignedInUser && props?.levelCd && (props?.rewardMember == 'Y' || !props?.rewardMember)) {
        updateDatalayer('mr_prof_member_level_abbr', props?.levelCd);
      }
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
    }

    return () => window.removeEventListener('load', onLoad);
  }, [isSignedInUser]);

  const [showSigInModalPopup, setShowSignInModalPopup] = useState(false);
  useEffect(() => {
    setShowSignInModalPopup(!isSignedInUser || !formData?.isUserEnableSignIn);
  }, [isSignedInUser, formData?.isUserEnableSignIn]);
  return (
    <div id="universal-Header">
      {isLoading && loadingFalse ? (
        <StyledHeader
          className="accordion-container brand-css"
          data-testid="header"
          data-component-name="o-account-header"
        >
          <div className={`col-12 m-accordion-container ${brandCdSetPage}`}>
            <div className="header-container">
              <div className={`d-flex flex-row flex justify-content-between logo-container`}>
                <div>
                  <div
                    className="skeleton-loader"
                    style={{
                      width: '150px',
                      height: '90px',
                    }}
                  ></div>
                  <div className="skeleton-loader"></div>
                </div>
                <div className={`right-container`} style={{ gap: '10px' }}>
                  <span
                    className="skeleton-loader"
                    style={{
                      width: '150px',
                      height: '16px',
                      marginBottom: '8px',
                      gap: '10px',
                    }}
                  ></span>
                  <div
                    className="skeleton-loader"
                    style={{
                      width: '150px',
                      height: '16px',
                      marginBottom: '8px',
                    }}
                  ></div>
                </div>
              </div>
              <div className="accordion-button d-flex flex-md-row align-items-start justify-content-around bottomLine p-0"></div>
              <div className="accordion-item d-flex sub-nav-container justify-content-start ">
                <div className="text-address">
                  <div
                    className="skeleton-loader"
                    style={{
                      width: '300px',
                      height: '35px',
                    }}
                  ></div>
                </div>
                <div className="navigation-btns ">
                  {[...Array(4)].map((_, index) => (
                    <div
                      key={index}
                      className="skeleton-loader"
                      style={{
                        width: '150px',
                        height: '16px',
                        marginLeft: '30px',
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </StyledHeader>
      ) : (
        <StyledHeader
          className="accordion-container brand-css"
          data-testid="header"
          data-component-name="o-account-header"
        >
          <div className={`col-12 m-accordion-container ${brandCdSetPage}`}>
            <div className="header-container">
              <div className="d-flex flex-row justify-content-between logo-container">
                <div>
                  {propertyLogo && (
                    <Image
                      defaultImageURL={`${propertyLogo}`}
                      altText={`${props.brandName ?? formData?.property_config?.brand_name} Logo`}
                      renditions={[
                        {
                          renditionPath: propertyLogo,
                          mediaValue: '992px',
                          width: 160,
                          dynamic: true,
                          damPath: propertyLogo,
                          mediaQuery: 'max-width',
                          height: 60,
                        },
                      ]}
                      className="header-logo"
                      customClass="header-logo"
                    />
                  )}
                </div>
                <div className="right-container">
                  {hotelPhoneNumber && (
                    <a
                      href={`tel:${hotelPhoneNumber}`}
                      aria-label="PhoneNumber"
                      className="custom_click_track"
                      data-custom_click_track_value={`Header|'Phone Number'|'Internal'`}
                    >
                      <span className="icon-phone">{!isMobileViewPort ? hotelPhoneNumber : ''}</span>
                    </a>
                  )}

                  {hotelEmail && (
                    <a
                      href={`mailto:${hotelEmail}?subject=Pre-Arrival Travel Planner Form - Reservation ${confirmationNumber}&body=`}
                      aria-label="Email"
                      className="custom_click_track"
                      data-custom_click_track_value={`${OUTLET_ADDITIONAL_SECTION}|${OUTLET_EMAIL_CONTACT}|${EXTERNAL_LINK}`}
                    >
                      <span className="icon-mail">{!isMobileViewPort ? hotelEmail : ''}</span>
                    </a>
                  )}

                  {/* <a
                        aria-label="language"
                        className="custom_click_track"
                        custom_click_track_value={`${OUTLET_ADDITIONAL_SECTION}|${OUTLET_EMAIL_CONTACT}|${EXTERNAL_LINK}`}
                    >
                        <span className="icon-globe">{!isMobileViewPort ? "English" : ""}</span>
                    </a> */}

                  {props.enableDynamicLocaleRequest === 'true' && (
                    <>
                      <a
                        data-component-name="a-ui-library-Button"
                        data-testid=""
                        className="custom_click_track language-selector-button-footer"
                        data-is-co-brand="false"
                        onKeyDown={toggleKeyHandler}
                        onClick={toggleHandler}
                        aria-label=""
                        tabIndex={0}
                        data-is-dca-enabled="false"
                      >
                        <span className="icon-globe">{!isMobileViewPort ? 'English' : ''}</span>
                      </a>

                      <LanguageSelector
                        currentLanguage={language}
                        clickTrackValue={`${OUTLET_ADDITIONAL_SECTION}|${OUTLET_EMAIL_CONTACT}|${EXTERNAL_LINK}`}
                        toggleHandler={toggleHandler}
                        setIsOpen={setIsLanguageSelectorOpen}
                        isOpen={isLanguageSelectorOpen}
                        languageSelectorModal={languageSelectorModal}
                      />
                    </>
                  )}

                  {signInTargetDisabledFlagAlternate != true &&
                    (isMobileAppBrowser() && (getPushSource == 'true' || appView) ? (
                      <></>
                    ) : (
                      <>
                        <button onClick={toggleSignInHandlerShow} className="icon-nav---account d-flex " tabIndex={0}>
                          <a
                            aria-label="Sign In"
                            className="custom_click_track"
                            data-custom_click_track_value={`${OUTLET_ADDITIONAL_SECTION}|${OUTLET_EMAIL_CONTACT}|${EXTERNAL_LINK}`}
                            // onClick={toggleSignInHandler}
                            style={{ textDecoration: 'none' }}
                          >
                            {!isMobileViewPort
                              ? isSignedInUser
                                ? `Hello, ${headerSubtext?.consumerName || formData?.userName}`
                                : isRememberedUser
                                ? `Sign In, ${headerSubtext?.consumerName || formData?.userName}`
                                : 'Sign In Or Join'
                              : ''}
                          </a>
                        </button>

                        {isSignedInUser && (
                          <SignInDrawer
                            isOpen={formData?.isSignInDrawerSideBarOpen}
                            togglePanel={toggleSignInHandlerClose}
                            modelData={props?.model}
                          />
                        )}
                        {showSigInModalPopup && (
                          <SignInModal
                            show={formData?.isSignInDrawerOpen}
                            onClose={toggleSignInHandlerClose}
                            modalData={props?.model}
                          />
                        )}
                      </>
                    ))}
                </div>
              </div>
              <div className="accordion-button d-flex flex-md-row align-items-start justify-content-around bottomLine p-0"></div>
              <div
                className={`accordion-item ${
                  !isMobileViewPort ? 'd-flex' : ''
                } sub-nav-container justify-content-start`}
              >
                <div className="text-address">
                  <h4 className="pr-3 my-auto t-brand-font-l">{propertyName}</h4>
                </div>
                {isMobileViewPort && (
                  <div className="accordion-button rgba(100, 100, 100, 1) d-flex flex-md-row align-items-start justify-content-around bottomLine p-0"></div>
                )}
                <div className="navigation-btns">
                  {headerLinks?.map((item: HeaderMenuItem) => {
                    const itemSegment = item?.linkPath?.split('/').pop()?.split('.')[0];
                    const page = router.query['page'];
                    const pageSegments = Array.isArray(page) ? page : [page];
                    const currentSegment = pageSegments?.[pageSegments.length - 1]?.split('.')[0];
                    const isActive = itemSegment === currentSegment;
                    const safeTitle = item.linkTitle
                      ? DOMPurify.sanitize(item.linkTitle, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
                      : '';
                    return (
                      <Link
                        key={item.linkTitle}
                        text={item.linkTitle}
                        linkClassName={`m-nav-link nav-link-items custom_click_track mr-0 ${isActive ? 'active' : ''} ${
                          !clickNav ? 'no-pointer-events' : ''
                        }`}
                        custom_click_track_value={`Header|${safeTitle}|Jump-${safeTitle.replace(/\s+/g, '')}`}
                        linkHref={item?.linkPath}
                        linkType="internal"
                        target="_self"
                        callback={handleClick}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </StyledHeader>
      )}
    </div>
  );
};

export const HeaderWrapperConfig = {
  emptyLabel: 'Header',
  isEmpty: false,
  resourceType: `mi-aem-prearrival/components/header`,
};
/* eslint-disable  @typescript-eslint/no-explicit-any */
export const HeaderEditable = (props: any) => {
  return (
    <EditableComponent {...props} config={HeaderWrapperConfig}>
      <Header {...props} />
    </EditableComponent>
  );
};
